export default __webpack_public_path__ + "static/media/59.b45b6ac3.jpg";